<div class="sidebar-container" [class.st-effect-1]="isSidebarOpen">
  <div class="sidebar-container_icons">
    <div class="sidebar-container_icons_item navigation-item">
      <button class="close-btn" aria-label="Cerrar" (click)="closeSidebar()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="sidebar-container_icons_item"></div>
    <div class="sidebar-container_icons_item"></div>
    @for (item of visibleMenuItems; track item) {
      @if (item.visible) {
        <a class="sidebar-container_icons_item navigation-item"
          [class.active]="activeIcon === item.id"
          [class.disabled]="item.requiresPermission && !perSideBar.canAccessModule(item.permissionKey!)"
          (mouseenter)="handleSectionHover(item)"
          (mouseleave)="handleSectionMouseLeave()"
          [attr.href]="getIconHref(item)"
          (click)="handleSectionClick(item, $event)">
          <img class="sidebar-icon" [class.disabled-icon]="item.requiresInfrastructure && !this.hasInfrastructures" [src]="item.icon" [alt]="item.label">
          <span [class.grey-text]="item.requiresInfrastructure && !this.hasInfrastructures">{{item.label}}</span>
        </a>
      }
      @if (!item.visible) {
        <div class="sidebar-container_icons_item"></div>
      }
    }
    <div class="sidebar-container_icons_item"></div>
    <div class="sidebar-container_icons_item"></div>
    <div class="sidebar-container_icons_item"></div>
    <button class="sidebar-container_icons_item navigation-item" (click)="support()">
      <img class="sidebar-icon sidebar-icon__support" src="assets/icons/sidebar/support.svg" alt="">
      <span>{{translateData['support'] || 'Support'}}</span>
    </button>
    <button class="sidebar-container_icons_item navigation-item" (click)="logout()">
      <img class="sidebar-icon" src="assets/icons/logout.svg" alt="">
      <span>{{translateData['logout'] || 'Logout'}}</span>
    </button>
  </div>

  <div class="sidebar-container_sections">
    <div class="sidebar-container_sections_next-logo">
      <img src="assets/icons/next.svg" alt="Next Logo">
    </div>
    
    @if(activeIcon && getSectionItems(activeIcon).length > 0 ) {
      <div class="sidebar-container_sections_subtitle" >{{translateData[activeIcon] || activeIcon}}</div>
      
      @for (item of getSectionItems(activeIcon); track item.id) {
        @if (shouldShowItem(item)) {
          @if (item.type === 'separator') {
            <div class="sidebar-container__separator" 
              [class.active]="activeSection === item.id"
              [class.sidebar-container__separator--disabled]="isItemDisabled(item)">
            </div>
          } @else {
            <a class="sidebar-container_sections_item" 
              [class.active]="activeSection === item.id"
              [class.disabled]="isItemDisabled(item) || (item.requiresInfrastructure && !hasInfrastructures)"
              [routerLink]="getRouteLink(item)"
              (click)="handleItemAction(item, $event)">
              <span>{{ item.label }}</span>
              
              @if (item.showBadge && petitionsCount > 0) {
                <div class="notification-badge">
                  {{petitionsCount}}
                </div>
              }
              
              @if (item.hasSubsections) {
                <div class="btn-arrow" (click)="toggleSection($event, item)">
                  <svg class="arrow-icon" [class.expanded]="expandedSections[item.id]" width="16" height="16" viewBox="0 0 24 24">
                    <path d="M6 9l6 6 6-6" stroke="white" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              }
            </a>
            
            @if (item.hasSubsections && expandedSections[item.id] ) {
              <div class="sidebar-subsections" [class.disabled]="isItemDisabled(item)">
                @for (subsection of item.subsections; track subsection.id) {
                  <a class="sidebar-container_subsection_item"
                    [class.active]="activeSubSection === subsection.id"
                    [routerLink]="getRouteLink(subsection)"
                    (click)="!hasInfrastructures && subsection.requiresInfrastructure ? $event.preventDefault() : closeSidebar()">
                    {{ subsection.label }}
                  </a>
                }
              </div>
            }
          }
        }
      }
    }
  </div>
</div>

<button data-effect="st-effect-1" (click)="toggleSidebar()" class="toggle-btn">
  <img class="menu-icon icon-header" src="assets/icons/header/menu.svg" alt="">
</button>

@if (isSidebarOpen) {
  <div class="overlay" [class.active]="isSidebarOpen" (click)="closeSidebar()">
  </div>
}